import * as React from 'react';
import * as Yup from 'yup';
import {inject, observer} from 'mobx-react';
import {Formik, FormikProps} from 'formik';
import BaseForm, {FormValues} from './private/LoginFormBase';
import {Auth} from '../../models/authModel';

interface WithInjectedProps {
  auth: Auth;
}

@inject('auth')
@observer
export default class LoginForm extends React.Component<{}, {}> {
  public render() {
    const isLoading = this._withInjectedProps.auth.isLoggingIn;

    return (
      <Formik
        initialValues={this._initialValues}
        validationSchema={this._validationSchema}
        onSubmit={this._handleSubmit}
        render={(props: FormikProps<FormValues>) => <BaseForm {...props} isLoading={isLoading} />}
      />
    );
  }

  private get _initialValues() {
    return {email: '', password: ''};
  }

  private get _validationSchema() {
    return Yup.object().shape({
      email: Yup.string()
        .email('E-mail is not valid.')
        .required('Please enter your email.'),
      password: Yup.string().required('Please enter a password.')
    });
  }

  private _handleSubmit = ({email, password}: FormValues) => {
    this._withInjectedProps.auth.login(email, password);
  };

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }
}



// WEBPACK FOOTER //
// ./src/containers/LoginForm/LoginForm.tsx